// model/Post.js
import { Model } from "@nozbe/watermelondb";
import { field, date } from "@nozbe/watermelondb/decorators";

export default class FetchMeta extends Model {
  static table = "fetch_meta";
  @date("last_fetch") lastFetch: Date | null;
  @field("initial_sync_occoured") initialSyncOccoured: boolean;
}
